import { Component } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';

@Component({
  standalone: false,
  selector: 'sbnb-dialog-parent-child-remove-relationship-confirm',
  template: `
    <section fxLayoutAlign="end center">
      <sbnb-close [border]="true" (click)="dialogRef.close()"></sbnb-close>
    </section>

    <section fxFlexFill fxLayout fxLayoutAlign="center center">
      <div class="fs-dialog-contents">
        <div fxLayout="column" fxLayoutGap="16px">
          <h2>Remove relationship</h2>
          <span>
            Removing the relationship between these properties means their calendars will no longer interact. Dates that
            were previously marked as unavailable because of a related property's booking will now be made available.
          </span>

          <span>This action can not be undone, but new relationships can be configured at any time.</span>
        </div>

        <div fxLayoutAlign="end center" fxLayoutGap="12px" style="margin-top: 32px">
          <sbnb-button type="secondary" (clicked)="dialogRef.close(false)">Cancel</sbnb-button>
          <sbnb-button (clicked)="dialogRef.close(true)">Remove relationship</sbnb-button>
        </div>
      </div>
    </section>
  `,
  styles: [
    `
      .fs-dialog-contents {
        max-width: 640px;
        width: 100%;
        max-height: 80vh;
      }
      span {
        line-height: 1.6;
      }
    `,
  ],
})
export class DialogParentChildRemoveRelationshipConfirm {
  constructor(public dialogRef: MatDialogRef<DialogParentChildRemoveRelationshipConfirm>) { }
}
